import { useState } from 'react';
import { useSelector } from 'react-redux';

import { useAsistentes } from './hooks/useAsistentes';

import { Asistente } from './components/Asistente';
import { AsistenteCreate } from './components/AsistenteCreate';
import { Error, Forbidden, Loader, PrimaryButton } from '../../components';

import styles from './Asistentes.module.css';
import { roles } from '../../types/types';

export const Asistentes = () => {

  const { user } = useSelector(state => state.auth);

  const { asistentesQuery: { isLoading, isError, data: asistentes } } = useAsistentes();

  const [asistenteCreateStatus, setAsistenteCreateStatus] = useState(false);

  const handleCrearAsistente = () => {
    setAsistenteCreateStatus(true);
  }

  const handleCancelarCrearAsistente = () => {
    setAsistenteCreateStatus(false);
  }

  return (user.rol === roles.MEDICO) ? (
    <>
      <div className={styles.header}>Asistentes</div>
      {(isLoading)
        ? <Loader />
        : <>
            {(isError)
            ? <Error />
            : <>
              {asistentes.map(asistente => <Asistente key={asistente._id} asistente={asistente} />)}
              {(asistenteCreateStatus)
              ? <>
                <AsistenteCreate handleCancelarCrearAsistente={handleCancelarCrearAsistente} />
              </>
              : <>
                <div className='d-flex justify-content-end'>
                  <PrimaryButton
                    icon="Plus"
                    inverse={true}
                    marginTop={false}
                    onClick={handleCrearAsistente}
                    text="Agregar Asistente"
                    type="button"
                  />
                </div>
              </>
              }
            </>
            }
        </>
      }
    </>
  ) : <div className='mt-3'><Forbidden /></div>
}
